export default function toLowerKebabCase(
  ...parts: Array<number | string>
): string {
  return parts.join('-').trim().replace(/\s+/g, '-').toLowerCase();
}
